<template>
  <router-link
    :to="'/articles/' + datas.id"
    v-if="stype === 'small'"
    class="feature-post d-block"
  >
    <div
      class="feature-post-thumb"
      :style="{
        backgroundImage: `url(${datas.coverurl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }"
    ></div>
    <div class="feature-post-content">
      <div class="post-meta">
        <div class="meta-categories">
          <router-link :to="'/articles/' + datas.id">{{ datas.channel }}</router-link>
        </div>
        <div class="meta-date">
          <span>{{ datas.createdat }}</span>
        </div>
      </div>
      <h4 class="title">
        <router-link :to="'/articles/' + datas.id">{{ datas.title }}</router-link>
      </h4>
    </div>
  </router-link>

  <router-link
    :to="'/articles/' + datas.id"
    v-else-if="stype === 'big'"
    class="single-play-post-item d-block"
  >
    <div
      class="single-play-post-bg"
      :style="{
        backgroundImage: `url(${datas.coverurl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '493px',
        height: '383px'
      }"
    ></div>

    <div class="single-play-post-content">
      <div class="post-meta">
        <div class="meta-categories">
          <router-link :to="'/articles/' + datas.id">{{ datas.channel }}</router-link>
        </div>
        <div class="meta-date">
          <span>{{ datas.createdat }}</span>
        </div>
      </div>
      <h3 class="title">
        <router-link :to="'/articles/' + datas.id">{{ datas.title }}</router-link>
      </h3>
    </div>
    <!--
    <div v-if="datas.action === 'play'" class="play-btn">
      <a class="video-popup" @click.prevent="$store.dispatch('toggleVideo')"
        ><i class="fas fa-play"></i></a>
    </div>
    <div v-if="datas.action === 'trending'" class="trending-btn">
      <a href="#"><i class="fas fa-bolt"></i></a>
    </div>
    -->
  </router-link>
</template>

<script>
export default {
  props: {
    datas: {
      type: Object,
    },
    stype: {
      type: String,
    },
  },
};
</script>

<style scoped>
.single-play-post-item {
  position: relative;
}

.single-play-post-bg {
  position: relative;
}

.play-btn,
.trending-btn {
  position: absolute;
  z-index: 1;
}

.play-btn {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.trending-btn {
  top: 10px;
  left: 10px;
}

.feature-post-thumb {
  /* 默认宽度和高度，适用于大屏幕 */
  width: 262px;
  height: 198px;
}

/* 中等屏幕，例如平板电脑 */
@media (max-width: 992px) {
  .feature-post-thumb {
    /* width: 30vw; */
    width: 100%;
    height: 22.5vw; /* 保持与默认尺寸相同的宽高比 */
  }
}

/* 小屏幕，例如手机 */
@media (max-width: 768px) {
  .feature-post-thumb {
    width: 100%;
    height: 75vw; /* 保持与默认尺寸相同的宽高比 */
  }
}

/* 超小屏幕 */
@media (max-width: 576px) {
  .feature-post-thumb {
    width: 100%;
    height: 75vw; /* 保持与默认尺寸相同的宽高比 */
  }
}

/* iPad Pro 1024 宽度 */
@media (max-width: 1024px) {
  .feature-post-thumb {
    width: 100%; /* 确保图片占满容器宽度 */
    height: auto; /* 自动计算高度以保持图片比例 */
    aspect-ratio: 262 / 198; /* 保持默认宽高比，262 和 198 是之前默认的宽高值 */
  }
}
</style>
